<template>
  <div v-if="!isReadOnly">
      <v-row>
        <v-col cols="12" xl="1" lg="1" md="1" sm="1">
          <span style="font-size:14px; display: inline-block;">{{ viItem.rowLabel }}:</span>
        </v-col>

        <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="max-width: 150px;">
          <wrs-v-number v-model="viItem.minValue" :label="viItem.minLabel"
                      stack-label outlined dense disabled format="decimal"
                      class="wrsInfo mr-4" style="display: inline-block;" />
        </v-col>

        <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="max-width: 150px;">
          <wrs-v-number v-model="viItem.maxValue" :label="viItem.maxLabel"
                      stack-label outlined dense disabled format="decimal"
                      :class="isOverMax ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'" style="display: inline-block;" />
        </v-col>

        <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="max-width: 150px;">
          <wrs-v-number v-model="viItem.roadValue" :label="viItem.roadLabel"
                      stack-label outlined dense disabled format="decimal"
                      :class="isOverRoad ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'" style="display: inline-block;" />
        </v-col>

        <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="max-width: 150px;">
          <wrs-v-number v-model="model" @input="emitInputEvent"
                      :label="viItem.label"
                      format="decimal" :errors="validationErrors"
                      stack-label outlined dense
                      :class="isOverRoad || isOverMax ? 'wrsInputHigh mr-4' : 'mr-4'" style="display: inline-block;" />
        </v-col>

        <v-col cols="12" xl="12" lg="12" md="12" sm="12">
          <wrs-label :label="axleSpacingLabel" :value="viItem.totalAxleSpacing | toMeterDecimal" v-if="viItem.totalAxleSpacing>0" style="display: inline-block;" />
        </v-col>

      </v-row>

        <!--<span style="font-size:14px; display: inline-block; width:60px">{{ viItem.rowLabel }}:</span>
        <wrs-v-number v-model="viItem.minValue" :label="viItem.minLabel"
                      stack-label outlined dense disabled format="decimal"
                      class="wrsInfo mr-4" style="display: inline-block; width:110px" />
        <wrs-v-number v-model="viItem.maxValue" :label="viItem.maxLabel"
                      stack-label outlined dense disabled format="decimal"
                      :class="isOverMax ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'" style="display: inline-block; width:110px" />
        <wrs-v-number v-model="viItem.roadValue" :label="viItem.roadLabel"
                      stack-label outlined dense disabled format="decimal"
                      :class="isOverRoad ? 'wrsInfoHigh mr-4' : 'wrsInfo mr-4'" style="display: inline-block; width:110px" />
        <wrs-v-number v-model="model" @input="emitInputEvent"
                      :label="viItem.label"
                      format="decimal" :errors="validationErrors"
                      stack-label outlined dense
                      :class="isOverRoad || isOverMax ? 'wrsInputHigh mr-4' : 'mr-4'" style="display: inline-block; width:110px" />
        <wrs-label :label="axleSpacingLabel" :value="viItem.totalAxleSpacing | toMeterDecimal" v-if="viItem.totalAxleSpacing>0" style="display: inline-block; width:110px" />-->
  </div>
</template>
<script>

  import WrsLabel from '../../WrsLabel.vue';
  import WrsVuetifyNumber from '../../WrsVuetifyNumber.vue';

  export default {
    components: {
      'wrs-label': WrsLabel,
      'wrs-v-number': WrsVuetifyNumber
    },
    props: {
      viItem: {
        type: Object,
        default: function () {
          return {
            value: 0,
            isOverMax: false,
            orderNumber: 1,
            minLabel: "",
            maxLabel: "",
            rowLabel: "",
            roadLabel: "",
            minValue: 0,
            maxValue: 0,
            roadValue: 0,
            totalAxleSpacing: 0,
            label: "",
            isRequired: false,
            requiredError: "",
            error: "",
            hasError: false
          };
        },
      },
      axleSpacingLabel: {
        type: String,
        default: ""
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      model: {
        get() {
          return this.viItem.value;
        },
        set(value) {
          this.viItem.value = value;
        }
      },
      validationErrors() {
        const errors = [];

        this.checkForErrors(this.viItem);
        if (this.viItem.hasError) errors.push(this.viItem.error);

        return errors;
      },
      isOverMax: function () {
        let res = false;
        if (!this.viItem.hasError) {
          res = this.viItem.isOverMax;
        }

        return res;
      },
      isOverRoad: function () {
        let res = false;
        if (!this.viItem.hasError) {
          res = this.viItem.isOverRoad;
        }

        return res;
      }
    },
    methods: {
      checkForErrors: (vi) => {
        if ((isNaN(vi.value) || vi.value <= 0)) {
          vi.hasError = true;
          vi.error = vi.requiredError;
          return;
        }

        vi.isOverMax = false;
        if (!vi.hasError) {
          if (vi.value > vi.maxValue) {
            vi.isOverMax = true;
          }
        }

        vi.isOverRoad = false;
        if (!vi.hasError) {
          if (vi.value > vi.roadValue) {
            vi.isOverRoad = true;
          }
        }



        vi.hasError = false;
        vi.error = "";
      },
      emitInputEvent: function () {
        this.$emit('input');
      }
    }
  }
</script>

<style>
</style>
